import Screen from "src/shared/components/layout/screen/Screen"
import "./Inventario.css"
import { headers, TypeArticleDeactivate, TypeArticleActivate } from "./constants/inventory"
import { useNavigate } from "react-router-dom"
import {
    useAlmacenesQuery,
    useGetAlmacenArticuloByIdLazyQuery,
    useInforme_InventarioQuery,
    GetAlmacenArticuloByIdQuery,
    TipoArticulo,
    Almacen,
    AlmacenArticulo,
} from "src/gql/schema"
import { useProfile } from "src/shared/hooks/useProfile"
import { useEffect, useMemo, useRef, useState } from "react"
import { Drop } from "../Cortes/home/sections/History"
import Touchable from "src/shared/components/general/touchable/Touchable"
import Icon from "src/shared/icons"
import TabMenu from "src/shared/components/navigation/tab-menu/TabMenu"
import { AddButton } from "../gastos/components/AddButton/AddGasto"
import SkeletonCards from "../gastos/components/gastos-list/SkeletonCard/SkeletonCard"
import { tableSkeletonRows } from "src/shared/components/layout/skeleton/TableSkeleton/TableSkeleton"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "src/store/store"
import { toggleInventarioDetailDrawer } from "src/store/inventario/inventario.slice"
import Carousel from "src/pages/inventario/components/carousel/Carousel"
import {
    MOSAIC_ESTADO_FILTERS,
    MOSAIC_ESTADO_FILTERS_ITEM_ALL,
    MosaicCategoryFilter,
    TODOS_ALMACEN_FILTER,
} from "./constants/mosaic-filters"
import { CardsHome } from "./sections/home/cards/CardsHome"
import { getCurrencyFormat } from "src/utils/string"
import FlexibleTable, {
    FlexibleTableRef,
    SortFilterValue,
    TableFilter,
} from "src/shared/components/data-display/FlexibleTable/FlexibleTable"
import Mosaic, { MosaicRef } from "./sections/mosaic/Mosaic"
import ProductDetails from "./sections/product-details/ProductDetails"
import DetalleProduccion from "./recipes-process/detalle/DetalleProduccion"
import useSortTable from "src/shared/hooks/useSortTable"
import Selector from "src/shared/components/forms/Selector/Selector"
import TablePaginatorWrapper from "src/shared/components/data-display/FlexibleTable/sections/TablePaginatorWrapper/TablePaginatorWrapper"
import useArticulosTableQuery from "./hooks/useArticulosTableQuery"
import { getDataTabs } from "./helpers/getDataTabs"
import { getDataTable } from "./helpers/getDataTable"
import getHeaders from "./hooks/getHeaders"
import LazySearch, { LazySearchRef } from "src/shared/sections/room-service/LazySearch/LazySearch"
import { FlexibleTableRow } from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface"
import useIsColaboradorActive from "src/shared/hooks/useIsColaboradorActive"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { RoleNames } from "src/shared/hooks/useAuth"

export interface FilterSortState {
    almacenFilters?: TableFilter[]
    tipoFilters?: TableFilter[]
    disponibilidadFilters?: TableFilter[]
    nameSort?: SortFilterValue
}

function Inventario(): JSX.Element {
    const skeletonCardsRef = useRef<HTMLDivElement>(null)
    const { formatCustomDate } = useFormatDate()
    const { hotel_id, rolName } = useProfile()
    const soloConsulta = rolName === RoleNames.coordinador

    const { InactiveModal, validateIsColabActive } = useIsColaboradorActive()
    const [almacenSelected, setAlmacen] = useState<string>(TODOS_ALMACEN_FILTER.value)
    const [search, setSearch] = useState<AlmacenArticulo | undefined | null>()
    const [onboarding, setOnboarding] = useState<boolean>(true)
    const [almacenes, setAlmacenes] = useState<any[]>([])
    const [dataTables, setDataTables] = useState<FlexibleTableRow[]>([])
    const [filterSortState, setfilterSortState] = useState<FilterSortState>()
    const [showGradient, setShowGradient] = useState(false)

    const { data: dataAlmacenes, refetch: reloadAlmacenes } = useAlmacenesQuery({
        variables: {
            hotel_id: hotel_id,
            eliminado: false,
            tipos_articulos: [TipoArticulo.Insumo, TipoArticulo.Proceso, TipoArticulo.Venta],
        },
    })

    const almacenesIds = useMemo(() => dataAlmacenes?.almacenes.map((a) => a.almacen_id), [dataAlmacenes])
    const [listView, setListView] = useState<boolean>(true)

    const [page, setpage] = useState(1)

    const {
        articulos,
        currentPage,
        totalPages,
        refecth: refecthArticulos,
        isLoading,
    } = useArticulosTableQuery({
        page,
        almacenSelected: almacenSelected || TODOS_ALMACEN_FILTER.label,
        almacenes: almacenesIds || [],
        filterSortState,
        disabled: !listView,
    })

    useEffect(() => {
        if (isLoading && skeletonCardsRef.current) {
            skeletonCardsRef.current.scrollIntoView({ block: "start" })
        }
    }, [isLoading])

    useEffect(() => {
        setpage(1)
    }, [listView])

    useEffect(() => {
        if (isLoading) {
            const mainContainer = document.querySelector(".screen")
            if (mainContainer) {
                (mainContainer as HTMLElement).scrollTo(0, 0)
            } else {
                window.scrollTo(0, 0)
            }
        }
    }, [isLoading])

    const navigate = useNavigate()
    const [productionDetail, setProductionDetail] = useState<boolean>(false)

    const { isInventarioDetailDrawerOpen, productosMosaic } = useSelector((root: RootState) => root.inventario)
    const dispatch = useDispatch()
    const [almacenHeader, setAlmacenHeader] = useState<{ value: string; valueToDisplay: string }[]>([])

    const [mosaicSelectedEstadoFilter, setMosaicSelectedEstadoFilter] = useState<any>(MOSAIC_ESTADO_FILTERS[0].value)
    const [mosaicSelectedCategoriaFilter, setMosaicSelectedCategoriaFilter] = useState<MosaicCategoryFilter>(
        TODOS_ALMACEN_FILTER.value
    )

    const [GetAlmacenArticuloByIdQuery] = useGetAlmacenArticuloByIdLazyQuery()

    const [dataCards, setDataCards] = useState<any>([])

    const [itemSelected, setItemSelected] = useState<GetAlmacenArticuloByIdQuery>()

    const {
        data: informe,
        refetch: reloadInforme,
        loading: isLoadingInforme,
    } = useInforme_InventarioQuery({
        variables: {
            hotel_id,
        },
    })

    useEffect(() => {
        const variables = { hotel_id: hotel_id }
        reloadInforme(variables)
    }, [])

    useEffect(() => {
        if (informe) {
            setDataCards([
                {
                    title: "Valor comercial",
                    number: getCurrencyFormat(informe?.informe_inventario?.valor_comercial),
                    titleToolTip: "Valor comercial",
                    toolTip: "Tu inventario al precio de venta.",
                },
                {
                    title: "Costo total de inventario",
                    number: getCurrencyFormat(informe?.informe_inventario?.costo_total_inventario),
                    titleToolTip: "Costo total de inventario",
                    toolTip: "Costo de tu inventario con base en el costo final de tus productos.",
                },
                {
                    title: "Cantidad de artículos",
                    number: informe?.informe_inventario?.cantidad_articulos || 0,
                    titleToolTip: "Cantidad de artículos",
                    toolTip: "Total de unidades con las que cuenta tu inventario.",
                },
                {
                    title: "Artículos por agotarse",
                    number: informe?.informe_inventario?.articulos_por_agotarse || 0,
                },
                {
                    title: "Artículos agotados",
                    number: informe?.informe_inventario?.articulos_agotados || 0,
                },
            ])
        }
    }, [informe])

    const onSortData = (value: { sort: "up" | "down" | null; fromHeader: string; idx: number } | null) => {
        if (!value) {
            return
        }
        setDataTables(
            useSortTable({
                i: value.idx,
                sortedData: dataTables,
                startList: dataTables,
                sortState: value.sort,
            })
        )
        setfilterSortState((v) => ({ ...v, nameSort: value }))
    }

    useEffect(() => {
        if (page === 1) {
            return
        }
        setpage(1)
    }, [almacenSelected, filterSortState])

    const isEmptyInventario = useMemo(() => !articulos?.length && onboarding && !isLoading, [onboarding, articulos])

    useEffect(() => {
        if (search) {
            return setAlmacen(search.almacen?.almacen_id || "")
        }
    }, [search])

    useEffect(() => {
        if (!isLoading && articulos && page === currentPage) {
            setDataTables(
                getDataTable({
                    almacenSelected,
                    articulos,
                    search,
                    formatCustomDate,
                })
            )
            setOnboarding(false)
        }
    }, [articulos, search, almacenHeader, isLoading, page, currentPage])

    useEffect(() => {
        const data = getDataTabs({ almacenes: (dataAlmacenes?.almacenes as Almacen[]) || [] })
        setAlmacenes(data.resultado)
        setAlmacenHeader(data.headers)
    }, [dataAlmacenes])

    const { headersAll } = getHeaders({ almacenHeader })

    function obtenerIdAlmacenArticuloPorArticulo(articuloId) {
        const articuloAlmacen = productosMosaic?.almacenes_articulos?.find(
            (almacenArticulo) => almacenArticulo.articulo_id === articuloId
        )
        return articuloAlmacen?.almacen_articulo_id || ""
    }

    const onConfirmChange = () => {
        const almacen_articulo_id = itemSelected?.almacen_articulo.almacen_articulo_id || ""
        GetAlmacenArticuloByIdQuery({
            variables: {
                almacen_articulo_id
            },
        }).then(({ data }) => {
            setItemSelected(data)
        })
        reloadInforme({ hotel_id: hotel_id, almacen_id: almacenSelected || null })
        reloadAlmacenes({
            hotel_id: hotel_id,
            eliminado: false,
        }).then((d) => {
            setMosaicSelectedCategoriaFilter(TODOS_ALMACEN_FILTER.label)
            refecthArticulos({
                almacenSelected: almacenSelected,
                page,
                almacenes_: d.data?.almacenes.map((a) => a.almacen_id),
            })
        })
    }

    const onSelectedFilters = (value: TableFilter[]) => {
        lazySearchRef.current?.handleClear()
        if (!value.length) {
            return setfilterSortState(undefined)
        }
        const filtersFormated: FilterSortState = {
            disponibilidadFilters: undefined,
            tipoFilters: undefined,
            almacenFilters: undefined,
        }
        value.forEach((v) => {
            if (v.fromHeader === "Disponibilidad") {
                filtersFormated.disponibilidadFilters = [...(filtersFormated.disponibilidadFilters || []), v]
            }
            if (v.fromHeader === "Tipo") {
                filtersFormated.tipoFilters = [...(filtersFormated.tipoFilters || []), v]
            }
            if (v.fromHeader === "Almacén") {
                filtersFormated.almacenFilters = [...(filtersFormated.almacenFilters || []), v]
            }
        })
        setfilterSortState((v) => ({ ...v, ...filtersFormated }))
    }

    const lazySearchRef = useRef<LazySearchRef>(null)
    const flexibleTableRef = useRef<FlexibleTableRef>(null)
    const { skeletonRows } = tableSkeletonRows({ headers: almacenSelected ? headers : headersAll })

    const mosaicRef = useRef<MosaicRef>(null)
    const [isMosaicEmpty, setIsMosaicEmpty] = useState(false)
    const mosaicFilter = useMemo(() => {
        return !!search || mosaicSelectedEstadoFilter.value !== MOSAIC_ESTADO_FILTERS_ITEM_ALL.value
    }, [search, mosaicSelectedEstadoFilter])

    return (
        <Screen
            className="inventario__screen"
            title={isEmptyInventario ? "¡Bienvenido a tu Inventario!" : "Inventario"}
            contentClassName="inventario"
            close={true}
            onClose={() => navigate("/u")}
            headerRight={
                isEmptyInventario ? null : (
                    <div className="inventario-screen-right">
                        <div className="inventario-screen-right-search">
                            <LazySearch
                                filtersTipoArticulo={[TipoArticulo.Insumo, TipoArticulo.Proceso, TipoArticulo.Venta]}
                                ref={lazySearchRef}
                                className="inventario-screen__table-input"
                                almacen
                                onChange={(v?: AlmacenArticulo | null) => {
                                    setSearch(v)
                                }}
                                onClear={(searched) => {
                                    setSearch(undefined)
                                }}
                            />
                            <Drop
                                title="Gestión de inventario"
                                options={[
                                    ...(soloConsulta
                                        ? []
                                        : [
                                            {
                                                label: "Transferencia de artículos",
                                                onClick: validateIsColabActive(() =>
                                                    navigate("/u/inventario/transfer-items")
                                                ),
                                            },
                                            {
                                                label: "Surtido de artículos",
                                                onClick: validateIsColabActive(() =>
                                                    navigate("/u/inventario/surtido-articulos")
                                                ),
                                            },
                                        ]),
                                    {
                                        label: "Historial de inventario",
                                        onClick: () => navigate("/u/inventario/historial-movimientos"),
                                    },
                                ]}
                            />
                        </div>
                        {!soloConsulta && (
                            <>
                                <Touchable
                                    className="cortes-screen-header-icon"
                                    style={{ height: 40, width: 40, alignItems: "center", padding: "10px", marginRight: 16 }}
                                    onClick={() => {
                                        navigate("receta-proceso")
                                    }}
                                >
                                    <Icon name="RecipeHistory" color="#0E0E0E" height={"20px"} width={"20px"} />
                                </Touchable>
                                <Touchable
                                    className="cortes-screen-header-icon"
                                    style={{ height: 40, width: 40, alignItems: "center", padding: "10px" }}
                                    onClick={() => {
                                        navigate("categoria")
                                    }}
                                >
                                    <Icon name="Gear" color="#0E0E0E" height={"20px"} width={"20px"} />
                                </Touchable>
                            </>
                        )}
                    </div>
                )
            }
        >
            {isEmptyInventario ? (
                <Carousel onConfirm={() => setOnboarding(false)} />
            ) : (
                <section className="inventario__container">
                    <section className="inventario_tabs_container">
                        <div className="inventario_tabs scrollbar__light-fat">
                            <TabMenu
                                tabList={almacenes}
                                value={almacenSelected}
                                onChange={(value) => {
                                    if (almacenSelected === value) {
                                        return
                                    }
                                    mosaicRef.current?.refetchMosaicArticulos({
                                        almacenSelected_: value,
                                        page: 1,
                                    })
                                    setOnboarding(false)
                                    setAlmacen(value || TODOS_ALMACEN_FILTER.value)
                                    flexibleTableRef.current?.setFiltersFromOuterState([])
                                    lazySearchRef.current?.handleClear()
                                    setSearch(undefined)
                                    reloadInforme({ hotel_id: hotel_id, almacen_id: value || null })
                                    setMosaicSelectedCategoriaFilter(value || TODOS_ALMACEN_FILTER.value)
                                    setMosaicSelectedEstadoFilter(MOSAIC_ESTADO_FILTERS_ITEM_ALL.value)
                                    mosaicRef.current?.setPage(1)
                                }}
                                showNumerOnNoItems={true}
                            />
                        </div>
                        <div
                            style={{
                                height: "40px",
                                justifyContent: "space-between",
                                alignItems: "center",
                                display: "flex",
                                columnGap: "10px",
                            }}
                        >
                            {!listView && (
                                <Selector
                                    iconMode
                                    iconTheme="primary"
                                    iconProps={{
                                        color: "var(--header)",
                                    }}
                                    value={mosaicSelectedEstadoFilter}
                                    options={MOSAIC_ESTADO_FILTERS}
                                    title=""
                                    icon="filterFill"
                                    onChange={(v) => {
                                        mosaicRef.current?.refetchMosaicArticulos({
                                            almacenSelected_: almacenSelected,
                                            page: 1,
                                            filterSortState_: {
                                                ...filterSortState,
                                                disponibilidadFilters: [
                                                    {
                                                        filter: v.value,
                                                        fromHeader: "",
                                                        idx: 0,
                                                    },
                                                ],
                                            },
                                        })
                                        setMosaicSelectedEstadoFilter({
                                            label: v.label,
                                            value: v.value,
                                        })
                                    }}
                                />
                            )}
                            <Touchable
                                className="cortes-screen-header-icon"
                                style={{ height: 40, alignItems: "center" }}
                                onClick={() => {
                                    // toggle mosaic / table
                                    setListView(!listView)
                                    // set category and filters to "Todos"
                                    setMosaicSelectedEstadoFilter(MOSAIC_ESTADO_FILTERS[0].value)
                                    setMosaicSelectedCategoriaFilter(MOSAIC_ESTADO_FILTERS[0].value.value)
                                }}
                            >
                                <Icon
                                    name={listView ? "dashboardFill" : "list"}
                                    color="#0E0E0E"
                                    height={"20px"}
                                    width={"20px"}
                                />
                            </Touchable>
                        </div>
                    </section>
                    {!(mosaicFilter && isMosaicEmpty && !listView) && (
                        <div className="inventario_home_cards_container">
                            {isLoadingInforme ? <SkeletonCards /> : <CardsHome data={dataCards} />}
                        </div>
                    )}
                    {listView ? (
                        <TablePaginatorWrapper
                            currentPage={currentPage || 1}
                            onChange={(p) => setpage(p)}
                            pages={totalPages || 1}
                        >
                            <div className={`inventario_list_container${showGradient ? " show-gradient" : ""}`}>
                                <FlexibleTable
                                    ref={flexibleTableRef}
                                    onSort={(value) => onSortData(value)}
                                    onSelectedFilters={onSelectedFilters}
                                    tableItems={{
                                        ...{
                                            headers: almacenSelected ? headers : headersAll,
                                            rows: isLoading
                                                ? skeletonRows
                                                : dataTables?.map((row, index) => ({
                                                    key: index,
                                                    value: row.value.map(({ value }, index) => ({
                                                        value:
                                                            !almacenSelected && index === headersAll.length - 1 ? (
                                                                <p
                                                                    className={
                                                                        "inventario-list-cell " +
                                                                        value?.toString().toLowerCase()
                                                                    }
                                                                >
                                                                    {value}
                                                                </p>
                                                            ) : almacenSelected && index === headers.length - 1 ? (
                                                                <p
                                                                    className={
                                                                        "inventario-list-cell " +
                                                                        value?.toString().toLowerCase()
                                                                    }
                                                                >
                                                                    {value}
                                                                </p>
                                                            ) : (
                                                                value
                                                            ),
                                                    })),
                                                    goTo: row.goTo,
                                                })),
                                        },
                                    }}
                                    goTo={(id) => {
                                        if (id) {
                                            GetAlmacenArticuloByIdQuery({
                                                variables: {
                                                    almacen_articulo_id: id
                                                },
                                            }).then(({ data }) => {
                                                setItemSelected(data)
                                                if (data?.almacen_articulo?.articulo?.tipo === TipoArticulo.Proceso) {
                                                    setProductionDetail(true)
                                                } else {
                                                    dispatch(toggleInventarioDetailDrawer(true))
                                                }
                                            })
                                        }
                                    }}
                                    emptyState={
                                        search === null
                                            ? {
                                                subTitle: "No se encontraron productos",
                                                headerIcon: "searchLg",
                                            }
                                            : {
                                                titile: "Sin artículos encontrados",
                                                subTitle: "No hay artículos con este estatus en tu almacén.",
                                                headerIcon: "packageFill",
                                            }
                                    }
                                    onHasScrollChange={setShowGradient}
                                ></FlexibleTable>
                            </div>
                        </TablePaginatorWrapper>
                    ) : (
                        <div className="inventario_cards_container">
                            <Mosaic
                                ref={mosaicRef}
                                searchValue={search}
                                emptyMosaic={setIsMosaicEmpty}
                                onSelectItem={(id) => {
                                    const almacen_articulo_id = obtenerIdAlmacenArticuloPorArticulo(id)
                                    if (almacen_articulo_id) {
                                        GetAlmacenArticuloByIdQuery({
                                            variables: {
                                                almacen_articulo_id
                                            },
                                        }).then(({ data }) => {
                                            setItemSelected(data)
                                            if (data?.almacen_articulo?.articulo?.tipo === TipoArticulo.Proceso) {
                                                setProductionDetail(true)
                                            } else {
                                                dispatch(toggleInventarioDetailDrawer(true))
                                            }
                                        })
                                    }
                                }}
                                filterCategoriaSelected={mosaicSelectedCategoriaFilter}
                                filterEstadoSelected={mosaicSelectedEstadoFilter.value}
                            ></Mosaic>
                        </div>
                    )}
                </section>
            )}
            <ProductDetails
                isOpen={isInventarioDetailDrawerOpen}
                almacenArticulo={itemSelected}
                onClose={() => {
                    dispatch(toggleInventarioDetailDrawer(false))
                }}
                onConfirmChange={onConfirmChange}
                deactivateType={TypeArticleDeactivate[itemSelected?.almacen_articulo.articulo?.tipo || ""]}
                activateType={TypeArticleActivate[itemSelected?.almacen_articulo.articulo?.tipo || ""]}
            />
            {productionDetail && (
                <DetalleProduccion
                    isOpen={true}
                    onClose={() => setProductionDetail(false)}
                    almacenArticulo={itemSelected?.almacen_articulo as any}
                    onConfirmChange={onConfirmChange}
                    deactivateType={TypeArticleDeactivate[itemSelected?.almacen_articulo.articulo?.tipo || ""]}
                    activateType={TypeArticleActivate[itemSelected?.almacen_articulo.articulo?.tipo || ""]}
                />
            )}
            {isEmptyInventario || soloConsulta ? null : (
                <AddButton onAdd={validateIsColabActive(() => navigate("/u/inventario/producto/agregar"))} />
            )}
            {InactiveModal}
        </Screen>
    )
}

export default Inventario
